import { render } from "./commisions.vue?vue&type=template&id=7d9945c5"
import script from "./commisions.vue?vue&type=script&lang=js"
export * from "./commisions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__